import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation } from "@apollo/client";
import { Form, message } from "antd";
import { TIME_FORMATS } from "utils/constants";
import GET_MY_SETTINGS from "graphql/queries/GetMySettings";
import UPDATE_PROFILE from "graphql/mutations/UpdateProfile";
import { TimeZone } from "types";
import * as StyledForm from "./ChangeTimeFormStyle";
import { CustomButton } from "./AfterSignUpStyle";

const ChangeTimeForm = () => {
  const { t } = useTranslation("after_sign_up");
  const [updateMyTimeForm] = Form.useForm();
  const { data } = useQuery(GET_MY_SETTINGS, {
    fetchPolicy: "network-only",
  });
  const [updateMyTime] = useMutation(UPDATE_PROFILE, {
    onCompleted: () => {
      message.success(t("Changes saved successfully!"));
    },
    onError: () => {
      message.error(t("Failed saving changes. Please try again."));
    },
  });
  useEffect(() => {
    if (data?.me) {
      // showing information
      updateMyTimeForm.setFieldsValue(data?.me);
    }
  }, [data, updateMyTimeForm]);
  const formatStoreValues = (values: any) => {
    const {
      /* eslint-disable @typescript-eslint/no-unused-vars */
      preference, // remove it from form value before submitting
      ...rest
    } = values;
    return {
      ...rest,
    };
  };

  if (!data) return null;
  const { timeZones } = data;
  const handleSubmit = async (values: any) => {
    await updateMyTime({
      variables: {
        input: {
          attributes: formatStoreValues(values),
        },
      },
    });
  };
  const renderTimeFormGroup = () => (
    <StyledForm.Group>
      <StyledForm.Content>
        {/* If you notice something weird, see this PR desc
        https://github.com/LTLOnline/flexi/pull/721 */}
        <StyledForm.Item style={{ marginTop: 8 }} name="timeZone">
          <StyledForm.Select showArrow showSearch>
            {timeZones.map((timeZone: TimeZone) => (
              <StyledForm.Select.Option
                value={timeZone.name}
                key={timeZone.name}
              >
                {timeZone.nameWithOffset}
              </StyledForm.Select.Option>
            ))}
          </StyledForm.Select>
        </StyledForm.Item>
        <StyledForm.Item style={{ marginTop: 8 }} name="timeFormat">
          <StyledForm.Select showArrow>
            {TIME_FORMATS.map(
              // eslint-disable-next-line react/no-unused-prop-types
              ({ code, format }: { code: string; format: string }) => (
                <StyledForm.Select.Option value={code} key={code}>
                  {format}
                </StyledForm.Select.Option>
              )
            )}
          </StyledForm.Select>
        </StyledForm.Item>
      </StyledForm.Content>
    </StyledForm.Group>
  );

  return (
    <div>
      <Form
        name="updateMyTime"
        form={updateMyTimeForm}
        layout="vertical"
        onFinish={handleSubmit}
      >
        {renderTimeFormGroup()}
        <CustomButton className="toggle-btn full" htmlType="submit">
          {t("Save Change").toUpperCase()}
        </CustomButton>
      </Form>
    </div>
  );
};
export default ChangeTimeForm;
